import { cookieHelper } from "./cookie";

export const setupAlertBar = () => {
    var bannerAlert = document.querySelector('#banner-alert');
    if(bannerAlert) {
        if(!cookieHelper.get('alertClosed')) {
            bannerAlert.style.display = 'block';
        }
        document.querySelector('#banner-alert .close').addEventListener('click', function(event) {
            bannerAlert.style.display = 'none';
            cookieHelper.set('alertClosed', true, 60 * 60);
        });
    }
}